import { IconButton, Tooltip } from "@mui/material";

export default function AccessibleIconButton({
  title,
  children,
  tooltipProps,
  ...props
}) {
  const safeTooltipProps = tooltipProps == null ? {} : { ...tooltipProps };
  return (
    <Tooltip title={title} {...safeTooltipProps}>
      <IconButton aria-label={title} {...props}>
        {children}
      </IconButton>
    </Tooltip>
  );
}
